import { styled } from "@mui/material";
import ContentPreview from "../Pages/Content/preview";
import SurveysPreview from "../Pages/Survey/preview";

import AffiliatePreview from "../Pages/Affiliate/preview";
import ReviewPreview from "../Pages/Review/preview";
import { useAppSelector } from "../../../../redux/hooks";
import { useMemo } from "react";
import { getBrandIds } from "@brandclub/common-ui";
import PurchaseRewardsPreview from "../Pages/PurchaseRewards/preview";

const OffersPageContainer = styled("div")({
  width: "100%",
});

const Offers = () => {
  const brandEntity = useAppSelector((state) => state.brandEntity?.entity);
  const { brandIds, brandclubIds } = useMemo(() => {
    const brandIds = getBrandIds(brandEntity);
    const { brandclubId } = brandEntity;
    return { brandIds, brandclubIds: [brandclubId] };
  }, [brandEntity]);
  return (
    <OffersPageContainer>
      <SurveysPreview
        brandclubIds={brandclubIds}
        backgroundColor="#fff"
        arrowColor="grey"
      />
      <ReviewPreview
        brandIds={brandIds}
        backgroundColor="#fff"
        arrowColor="grey"
      />
      <ContentPreview
        brandclubIds={brandclubIds}
        backgroundColor="#fff"
        arrowColor="grey"
      />
      <AffiliatePreview brandIds={brandIds} arrowColor="grey" />
      <PurchaseRewardsPreview
        brandIds={brandIds}
        isFiniteScroll
        pageSize={10}
      />
    </OffersPageContainer>
  );
};

export default Offers;
